import EmptyScreen from "./EmptyScreen";

export default EmptyScreen;
